import { useState, useEffect } from 'react';
import ComponentsTable from './components/ComponentsTable';
import Spinner from '../../../../components/UI/Spinner/Spinner';
import { GetApplicationManagementByID } from '../../_api';
import Section from '../../components/NewApplication/Section';
const ComponentManagement = ({
	appID,
	currentUser,
	requirementNumber,
	readOnly,
}) => {
	const [app, setApp] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	//on load, retrieve the AppManagementModel for the selected app
	useEffect(() => {
		reload();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const reload = () => {
		setIsLoading(true);
		GetApplicationManagementByID(appID)
			.then(response => {
				setApp(response);
			})
			.then(x => setIsLoading(false));
	};

	return (
		<>
			<Section label='Components'>
				{isLoading ? (
					<Spinner />
				) : (
					<div>
						<ComponentsTable
							app={app}
							components={app.components}
							currentUser={currentUser}
							reload={reload}
							readOnly={readOnly}
							requirementNumber={requirementNumber}
						/>
					</div>
				)}
			</Section>
		</>
	);
};

export default ComponentManagement;
